import { isServer } from '~/utils/runtime';

/** A resolved fetch error carrying the HTTP status to surface on the error page. */
export interface ServerFetchError {
  statusCode: number;
  message: string;
}

/**
 * Server-side hard-fail for a resolved fetch error, so crawlers receive a real 404/500 instead
 * of a 200 "not found" shell (audit M5). A no-op on the client, where the page's `showError`
 * covers SPA navigation. `message` should already be translated by the caller — it surfaces as
 * the error-page heading. Uses `isServer` (not `import.meta.server`) so the branch is stubbable
 * in Vitest, mirroring the SSR throw `usePublicResourcePage` already performs.
 */
export const throwOnServerFetchError = (error: ServerFetchError | null | undefined): void => {
  if (isServer && error) {
    throw createError({ statusCode: error.statusCode, statusMessage: error.message });
  }
};
